/**
 * Content hashing for SOP optimistic concurrency (CAS).
 *
 * The backend records each SOP draft revision under a sha256 of its markdown. To
 * detect lost updates, the client sends the hash of the content it loaded as
 * `expectedContentHash`; the backend rejects the save (409) if the open draft has
 * since changed. This must produce the SAME digest as the backend
 * (`crypto.createHash('sha256').update(markdown, 'utf8').digest('hex')`).
 */

/** Lowercase hex sha256 of a UTF-8 string, via the Web Crypto API. */
export async function computeContentHash(content: string): Promise<string> {
  const bytes = new TextEncoder().encode(content);
  const digest = await crypto.subtle.digest('SHA-256', bytes);
  return Array.from(new Uint8Array(digest))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
}
